import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  container: css`
    margin-bottom: 24px;
    display: flex;
    flex-direction: column;
    gap: 8px;
    /* padding: 0px 8px; */
    /* align-items: center; */
    width: 100%;
    min-height: ${pxToRem(232)};
    border-radius: 12px;
    box-shadow: 0px 1px 3px 0px rgba(0, 0, 0, 0.3), 0px 4px 8px 3px rgba(0, 0, 0, 0.15);

    background: ${colors.white};
    cursor: pointer;
  `,
  icon: css`
    margin: 24px 0px 8px 0px;
  `,
  content: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    flex: 1;
  `,
  header: css`
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-bottom: 16px;
  `,
  footer: css`
    display: flex;
    flex-direction: row;
    width: 100%;
    min-height: ${pxToRem(82)};
    border-top: 1px solid ${colors.mercury};
    justify-content: space-between;
    & > div:first-child {
      border-right: 1px solid ${colors.mercury};
    }
  `,
  footerInfo: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
  `,
  label: css`
    padding-bottom: 4px !important;
  `,
  updateLabel: css`
    font-size: ${pxToRem(18)};
    color: ${colors.prussian};
    font-weight: bold;
  `,
};

export default styles;
